/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Manage_TitleInputs */

const en_story_manage_title = /** @type {(inputs: Story_Manage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Active Stories`)
};

const es_story_manage_title = /** @type {(inputs: Story_Manage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar Historias Activas`)
};

const fr_story_manage_title = /** @type {(inputs: Story_Manage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer les Stories actives`)
};

const de_story_manage_title = /** @type {(inputs: Story_Manage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Stories verwalten`)
};

const id_story_manage_title = /** @type {(inputs: Story_Manage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola Cerita Aktif`)
};

/** @type {(inputs: Story_Manage_TitleInputs) => LocalizedString} */
const ja_story_manage_title = en_story_manage_title;

/** @type {(inputs: Story_Manage_TitleInputs) => LocalizedString} */
const zh_story_manage_title = en_story_manage_title;

/** @type {(inputs: Story_Manage_TitleInputs) => LocalizedString} */
const ar_story_manage_title = en_story_manage_title;

/** @type {(inputs: Story_Manage_TitleInputs) => LocalizedString} */
const it_story_manage_title = en_story_manage_title;

/** @type {(inputs: Story_Manage_TitleInputs) => LocalizedString} */
const ru_story_manage_title = en_story_manage_title;

/** @type {(inputs: Story_Manage_TitleInputs) => LocalizedString} */
const pt_story_manage_title = en_story_manage_title;

/** @type {(inputs: Story_Manage_TitleInputs) => LocalizedString} */
const ko_story_manage_title = en_story_manage_title;

/**
* | output |
* | --- |
* | "Manage Active Stories" |
*
* @param {Story_Manage_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_manage_title = /** @type {((inputs?: Story_Manage_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Manage_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_manage_title(inputs)
	if (locale === "es") return es_story_manage_title(inputs)
	if (locale === "fr") return fr_story_manage_title(inputs)
	if (locale === "de") return de_story_manage_title(inputs)
	if (locale === "ja") return ja_story_manage_title(inputs)
	if (locale === "zh") return zh_story_manage_title(inputs)
	if (locale === "ar") return ar_story_manage_title(inputs)
	if (locale === "id") return id_story_manage_title(inputs)
	if (locale === "it") return it_story_manage_title(inputs)
	if (locale === "ru") return ru_story_manage_title(inputs)
	if (locale === "pt") return pt_story_manage_title(inputs)
	return ko_story_manage_title(inputs)
});